<div class="hedge__order__monitor__staging__grid__container" fxLayout="row" fxFlex="1 1 auto">
  <ag-grid-angular
    fxFlex="1 1 auto"
    class="ag-bcdfx"
    enableColResize
    singleClickEdit
    multiSortKey="ctrl"
    [frameworkComponents]="frameworkComponents"
    [stopEditingWhenGridLosesFocus]="true"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    [ngClass]="{ intentStyled: isIntentStyled === true }"
    (contextmenu)="showColumnSelector($event)"
  >
  </ag-grid-angular>
</div>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>
<bfx-hedge-order-strategy-parameters #strategyParameters></bfx-hedge-order-strategy-parameters>
